import React, { useEffect, useState } from 'react';
import fetchBase from "../utils/fetchBase";
import axios from 'axios';
import './EmployeeHistory.css';
import OuraNav from "../components/OuraNav";


const EmployeeHistory = () => {
    const [timeLogs, setTimeLogs] = useState([]);
    const organizationName = 'Divine Home Health';

    useEffect(() => {
         
        const token = localStorage.getItem("jwt_token");

        axios.get(`${fetchBase}/api/admin/history`, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
            .then(res => {
                console.log("Time log response:", res.data);
                setTimeLogs(res.data);
            })
            .catch(err => {
                console.error("Failed to fetch time logs", err);
            });
    }, []);
    const handleDelete = (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this time log?");
        if (!confirmDelete) return;

        const authHeader = localStorage.getItem("authHeader");

        axios.delete(`${fetchBase}/api/time-log/${id}`, {
            headers: {
                Authorization: authHeader
            }
        })
            .then(() => {
                setTimeLogs(prev => prev.filter(log => log.id !== id));
            })
            .catch(err => {
                console.error("Failed to delete time log", err);
            });
    };



    return (
        <>
            <OuraNav
                links={[
                    { label: "Dashboard", href: "/admin-dashboard" },
                    { label: "Employees", href: "/employees" },
                    { label: "Clients", href: "/admin/clients" },
                    { label: "Activity", href: "/activity" },
                    { label: "Payroll", href: "/admin/payroll" }
                ]}
            />

            <div className="page-bg">
            <div className="card-container">
                <div className="card-header">
                    <h2>Time Log History</h2>
                    <span className="org-name">{organizationName}</span>
                </div>

                <table className="log-table">
                    <thead>
                    <tr>
                        <th>Client</th>
                        <th>Employee</th>
                        <th>Clock In Date</th>
                        <th>Clock In Time</th>
                        <th>Clock Out Time</th>
                    </tr>
                    </thead>
                    <tbody>
                    {timeLogs.map((log) => (
                        <tr
                            key={log.id}
                            className="log-row"
                            onMouseEnter={() => log.hover = true}
                            onMouseLeave={() => log.hover = false}
                        >
                            <td>{log.clientName}</td>
                            <td>{log.employeeName}</td>
                            <td>{new Date(log.clockInTime).toLocaleDateString()}</td>
                            <td>{new Date(log.clockInTime).toLocaleTimeString([], {
                                hour: 'numeric',
                                minute: '2-digit',
                                hour12: true
                            })}</td>
                            <td>
                                {log.clockOutTime !== "--"
                                    ? new Date(log.clockOutTime).toLocaleTimeString([], {
                                        hour: 'numeric',
                                        minute: '2-digit',
                                        hour12: true
                                    })
                                    : "--"}
                            </td>
                            <td>
                <span
                    className="delete-icon"
                    onClick={() => handleDelete(log.id)}
                    title="Delete"
                >
                    🗑️
                </span>
                            </td>
                        </tr>
                    ))}
                    </tbody>

                </table>
            </div>
                </div>
            </>
        );
        };

export default EmployeeHistory;
